import { render } from "./NumberedTitle.vue?vue&type=template&id=066c4396&scoped=true"
import script from "./NumberedTitle.vue?vue&type=script&lang=js"
export * from "./NumberedTitle.vue?vue&type=script&lang=js"

import "./NumberedTitle.vue?vue&type=style&index=0&id=066c4396&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066c4396"]])

export default __exports__